module.exports = __webpack_public_path__ + "static/media/tree-step.a8f1e39e.svg";